<div class="td-cnt-ext">
    <div class="td-cnt" [ngClass]="{'td-cnt-mobile' : isMobile}" id="teiasoftDialog">
        <div class="td-cnt-title">
            <div>
                <i class="fal fa-edit dialog-icon"></i>
                <span class="te-title">{{'enquiryBook.editInPlace' | translate}} - {{this.enquiryNo}}</span>
                <span class="settings-btn" (click)="onClickShowSettings()"><i class="fa-wrench fal"></i></span>
            </div>
        </div>
        <div class="td-cnt-body">
            <teiasoft-datasheet *ngIf="!isLoading" style="width:100%" [dataSet]="dataSet" [theme]="theme"
                [isMobile]="isMobile" [columnsToHide]="columnsToHide" [columnsToShow]="columnsToShow"
                (changedDataset)="onChangedDataset($event)" [columnsNotEditable]="columnsNotEditable"
                [columnsRequired]="columnsRequired" [columnsSelect]="columnsSelect" [columnsBoolean]="columnsBoolean"
                [itemParameterValues]="itemParameterValues" [itemsFromXlsx]="itemsFromXlsx"
                (validForm)="validForm($event)" (itemsToDelete)="onSetItemsToDelete($event)"
                (setIsInEdit)="setIsInEdit($event)" (gridReady)="onGridReady()"
                [roundDigitsForEditInPlace]="roundDigitsForEditInPlace"
                [enquiry]="enquiry" [showSettingsInput]="showSettings" [materials]="materials"></teiasoft-datasheet>
        </div>
        <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
            <teiasoft-button (onClick)="onSaveEditClick()" class="mr-5" [type]="'tb-secondary'"
                [text]="'commons.save' | translate" [isMobile]="isMobile"
                [disabled]="isSaveDisabled()"></teiasoft-button>
            <teiasoft-button (onClick)="onCloseModalClick()" [type]="'tb-cancel'" [text]="'commons.cancel' | translate"
                [theme]="theme" [isMobile]="isMobile"></teiasoft-button>
        </div>
    </div>
</div>
